import React, { useState, useEffect } from "react";
import {
  List,
  CrudForm,
  crudFormEnums,
  ListApi,
  FormApi,
  DatePicker,
  SimpleFormDialog,
  SimpleDialog,
  Autocomplete,
  MountEntity,
  autocompleteHelpers,
  loopback,
  Filter,
} from "elentari";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import { TextField } from "final-form-material-ui";
import SendIcon from "@material-ui/icons/Send";
import { Field } from "react-final-form";
import { inbodyApi, clienteApi } from "../../services/Api";
import { mountImagesForm } from "./imageLib";
import { path } from "ramda";
import ImagePicker from "../../components/ImagePicker";
import { getFcmAfterLoad } from "../Fcm/getFcmAfterLoad";

const { toOption } = autocompleteHelpers;
const { loopbackFilters } = loopback;

const loadClientes = async (inputValue) => {
  const response = await clienteApi.getList({
    where: {
      nome: loopbackFilters.regexp(inputValue),
    },
    order: "nome asc",
    limit: 40,
  });
  if (response.ok) {
    return response.data.map(toOption("nome"));
  }
  return [];
};

function InbodyFilter(props) {
  return (
    <Filter
      formatFilters={{ clienteId: (value) => value.id }}
      labels={{ find: "Buscar", clear: "Limpar" }}
    >
      <Grid spacing={24} container>
        <Grid item xs>
          <Field
            label="Cliente"
            loadOptions={loadClientes}
            component={Autocomplete}
            name="clienteId"
          />
        </Grid>
      </Grid>
    </Filter>
  );
}

export function InbodyList(props) {
  const id = props.match.params.childId
    ? props.match.params.childId
    : props.match.params.id;
  const isFromCliente = !!props.match.params.id;

  const listOptions = {
    defaultOrder: "data desc",
    fields: {
      cliente: isFromCliente
        ? null
        : {
            label: "Cliente",
          },
      data: {
        label: "Data",
        format: (date) => (date ? moment(date).format("DD/MM/YYYY") : ""),
      },
      peso: {
        label: "Peso (Kg)",
      },
      mme: {
        label: "Massa Muscular Esquelética Kg",
      },
      gordura: {
        label: "Gordura (Kg)",
      },
      percentual: {
        label: "Percentual de Gordura",
      },
    },
  };

  const getPageDecorator = async ({ getPage }) => {
    const items = await getPage();
    if (!items) return;
    if (isFromCliente) return items;
    const promises = items.map(async (item) => {
      const response = await clienteApi.getOne(item.clienteId);
      if (response.ok) {
        item.cliente = response.data.nome;
        item.clienteId = undefined;
        return item;
      }
      return item;
    });
    return Promise.all(promises);
  };

  return (
    <ListApi
      api={inbodyApi}
      getPageDecorator={getPageDecorator}
      where={isFromCliente ? { clienteId: +id } : null}
    >
      {({ getPage, getCount, handleDelete }) => (
        <>
          <InbodyFilter />
          <List
            {...props}
            withPaper={props.withPaper}
            deleteItem={handleDelete}
            getPage={getPage}
            getCount={getCount}
            listOptions={listOptions}
          />
        </>
      )}
    </ListApi>
  );
}

export function InbodyForm(props) {
  const [statusNotificacao, setStatusNotificacao] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errorOnSendMessage, setErrorOnSendMessage] = useState(false);
  const FCMUtils = getFcmAfterLoad();

  const id = props.match.params.childId
    ? props.match.params.childId
    : props.match.params.id;
  const clienteId = props.match.params.childId && props.match.params.id;
  const isNew = id === "new" || id === "new-child";

  const fetchInbody = async (event) => {
    if (isNew) {
      setStatusNotificacao(false);
      return;
    }

    const response = await inbodyApi.getOne(id);
    if (clienteId) FCMUtils.getClientFcmById(clienteId);
    if (response.ok) setStatusNotificacao(response.data.notificado);
  };

  useEffect(() => {
    fetchInbody();
  }, []);

  const getItemDecorator = async ({ getItem, filter }) => {
    if (!clienteId && props.showClient && !isNew) {
      const result = await MountEntity(props, inbodyApi.getOne)
        .populate(({ data, id }) => ({
          cliente: clienteApi.getOne(data.clienteId),
        }))
        .clean(["clienteId"])
        .map((data) => ({
          ...data,
          cliente: toOption("nome")(data.cliente),
        }))
        .getItem();
      FCMUtils.getClientFcmById(result.cliente.id);
      return result.id ? result : { data: moment().format() };
    }
    return getItem(filter);
  };
  const validate = (values) => ({
    data: values.data ? undefined : "Obrigatório",
    cliente: !props.showClient || values.cliente ? undefined : "Obrigatório",
    mme: values.mme ? undefined : "Obrigatório",
    gordura: values.gordura ? undefined : "Obrigatório",
    percentual: values.percentual ? undefined : "Obrigatório",
    peso: values.peso ? undefined : "Obrigatório",
  });

  const submitDecorator = async ({ data, id, handleSubmit }) => {
    const result = await handleSubmit({
      id,
      data: {
        ...data,
        cliente: undefined,
        clienteId: clienteId ? Number(clienteId) : data.cliente.id,
        data: data.data,
        peso: data.peso ? +data.peso : undefined,
        percentual: data.percentual ? +data.percentual : undefined,
        mme: data.mme ? +data.mme : undefined,
        gordura: data.gordura ? +data.gordura : undefined,
        imagemFrente: Array.isArray(data.imagemFrente)
          ? undefined
          : data.imagemFrente,
        imagemCostas: Array.isArray(data.imagemCostas)
          ? undefined
          : data.imagemCostas,
        imagemLateral: Array.isArray(data.imagemLateral)
          ? undefined
          : data.imagemLateral,
      },
    });
    FCMUtils.getClientFcmById(clienteId ? Number(clienteId) : data.cliente.id);
    const imagesForm = mountImagesForm(data);
    if (result.ok && imagesForm)
      await inbodyApi.uploadImages(
        path(["data", "id"], result) || id,
        imagesForm
      );

    return result;
  };

  const enviarNotificacao = async (title, body) => {
    const response = await inbodyApi.notify(id, { title, body });
    if (!response.ok) setErrorOnSendMessage(true);
  };

  const customActions = [
    {
      label: statusNotificacao ? "Notificar novamente" : "Notificar",
      icon: <SendIcon style={{ marginLeft: 10 }} />,
      onClick: () => setDialogOpen(true),
      pristine: crudFormEnums.PRISTINE_BEHAVIOR.DISABLED_WHEN_DIRTY,
    },
  ];

  return (
    <div>
      <FormApi
        {...props}
        initialData={{ data: moment().format() }}
        submitDecorator={submitDecorator}
        getItemDecorator={getItemDecorator}
        api={inbodyApi}
      >
        {({ handleSubmit, getItem }) => (
          <CrudForm
            {...props}
            validate={validate}
            customActions={!isNew ? customActions : []}
            getItem={getItem}
            onSubmit={handleSubmit}
          >
            <Grid container direction="column" spacing={16}>
              <Grid item>
                <Grid container spacing={16}>
                  {props.showClient && (
                    <Grid item sm xs={12}>
                      <Field
                        label="Cliente"
                        loadOptions={loadClientes}
                        component={Autocomplete}
                        name="cliente"
                      />
                    </Grid>
                  )}
                  <Grid item sm xs={12}>
                    <Field
                      fullWidth
                      label="Data"
                      component={DatePicker}
                      name="data"
                    />
                  </Grid>
                  <Grid item sm xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      autoFocus
                      component={TextField}
                      label="Peso"
                      name="peso"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container spacing={16}>
                  <Grid item sm xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Massa Muscular Esquelética (MME)"
                      name="mme"
                    />
                  </Grid>
                  <Grid item sm xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Gordura"
                      name="gordura"
                    />
                  </Grid>
                  <Grid item sm xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Percentual"
                      name="percentual"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid container justify="space-around" style={{ marginTop: 18 }}>
                <Grid item>
                  <Field
                    fullWidth
                    width={150}
                    height={300}
                    defaultImage={require("../../images/empty-image.png")}
                    component={ImagePicker}
                    label="Frente"
                    name="imagemFrente"
                  />
                </Grid>
                <Grid item>
                  <Field
                    fullWidth
                    width={150}
                    height={300}
                    defaultImage={require("../../images/empty-image.png")}
                    component={ImagePicker}
                    label="Lateral"
                    name="imagemLateral"
                  />
                </Grid>
                <Grid item>
                  <Field
                    fullWidth
                    width={150}
                    height={300}
                    defaultImage={require("../../images/empty-image.png")}
                    component={ImagePicker}
                    label="Costas"
                    name="imagemCostas"
                  />
                </Grid>
              </Grid>
            </Grid>
          </CrudForm>
        )}
      </FormApi>
      <SimpleFormDialog
        title="Notificar"
        open={dialogOpen}
        buttonLabel="Cancelar"
        primaryAction={(title, body) =>
          enviarNotificacao(title, body).then(fetchInbody)
        }
        primaryActionButtonLabel="Enviar"
        firstFormLabel="Título"
        firstDefaultValue="Avaliação"
        secondFormLabel="Mensagem"
        secondDefaultValue="Sua avaliação está disponível!"
        disabledText={FCMUtils.state}
        handleClose={() => setDialogOpen(false)}
      />
      <SimpleDialog
        title="Atenção"
        message="Ocorreu um erro no envio da mensagem, por favor tente novamente mais tarde."
        open={errorOnSendMessage}
        primaryActionButtonLabel="Ok"
        handleClose={() => setErrorOnSendMessage(null)}
      />
    </div>
  );
}
